import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { runInAction } from 'mobx';
import { Modal } from 'app/components/Modal';
import { useEffect, useMemo } from 'react';
import { useField, useFormikContext } from 'formik';
import { IJpgThemaDef } from 'app/stores/ui/jpg.themen.ui.store';
import { ITableColumn, TableModel } from '../../table/table.model';
import { Table } from '../../table/table';
import { Button } from '../../common/Button';
import { AgenturModel } from 'app/models/agentur.model';
import { formatBool, Jpg25RoleVM, steartsSchema } from './Jpg25DocumentShareModal';

interface IJpg25DocumentShareFocusThemaModal {
	agt: AgenturModel;
	year: number;
	def: IJpgThemaDef;
}

export const Jpg25DocumentShareFocusThemaModal = observer((props: IJpg25DocumentShareFocusThemaModal) => {
	const { uiStore } = useStore();
	const modalId = uiStore.modalIds.documentShareJpg25FocusThemaModal;
	const { setFieldValue } = useFormikContext();
	const [field] = useField('share');
	const share = field.value as number[];
	const orgValues = [...field.value]; // clone

	const tm = useMemo(() => {
		const tm = new TableModel<Jpg25RoleVM, number>();
		const cols: ITableColumn<Jpg25RoleVM, number>[] = [];

		props
			.agt!.users.filter((u) => !u.isVBL)
			.forEach((u) => {
				cols.push({
					label: u.name + ' ' + u.steartText,
					path: u.bnrId.toString(),
					format: formatBool,
					editType: 'checkbox',
					editable: true,
				});
			});

		tm.setCols(cols);
		tm.editMode = true;
		tm.hideEditModeHeader = true;
		tm.useDetachedFooter = true;
		tm.saveButtonText = 'Übernehmen';
		tm.idType = 'number';
		tm.idProperty = 'index';
		tm.editDisabled = false;
		tm.sortDisabled = true;
		return tm;
	}, [props.agt]);
	tm.setEditMode(true);

	const onCancel = () => {
		runInAction(() => {
			setFieldValue('share', orgValues);
			uiStore.hideModal(modalId);
			tm.setEditMode(true);
		});
	};

	useEffect(() => {
		const data: Jpg25RoleVM[] = [];
		data.push(new Jpg25RoleVM(props.def, share, 1, props.agt!.users));
		tm.setRowData(data);
	}, [share, tm, props.def, props.agt]);

	const onSave = () => {
		const row = tm.data[0];
		setFieldValue('share', row.getBnrIds(props.agt.users));
		uiStore.hideModal(modalId);
	};

	const allOrNone = () => {
		const val = tm.data[0].getState(props.agt!.users[0].bnrId);
		tm.data.forEach((vm) => {
			vm.setAll(props.agt!.users, !val);
		});
		tm.setRowData(tm.data);
	};

	return (
		<>
			<Modal modalId={modalId} title={'JPG Focus Thema ' + props.def.thema + ' teilen mit: '} size="large" modifier="is-paddingless" onClose={onCancel}>
				<div className="pad-1rem">
					<Button type="button" className="button is-small is-primary is-inverted" onClick={allOrNone}>
						Alle / Keine
					</Button>
				</div>
				<div>
					<Table tm={tm} onSubmit={onSave} schema={steartsSchema} onCancel={onCancel} />
				</div>
			</Modal>
		</>
	);
});
